import { render, staticRenderFns } from "./TriangleSmallUp.vue?vue&type=template&id=8bb0477c"
import script from "./TriangleSmallUp.vue?vue&type=script&lang=js"
export * from "./TriangleSmallUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports